import React from "react";

const Tools = () => (
  <svg width="278px" height="280px" viewBox="0 0 278 280">
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      strokeWidth={2.5}
    >
      <g id="234_Davos_smart-data" transform="translate(1.000000, 1.000000)">
        <polygon
          id="Shape"
          stroke="#FFAF3E"
          fill="#1A1C35"
          fill-rule="nonzero"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="111.14991 184.932613 110.699099 169.705225 111.30018 164.596036 159.987748 142.356036 193.397838 146.763964 201.111712 146.413333 210.027748 139.901622 218.943784 140.352432 223.301622 138.198559 231.516396 139.10018 264.976577 149.96973 276.447207 160.839279 275.745946 165.898378 262.922883 177.81982 258.965766 187.587387 256.912072 195.551712 253.706306 198.957838 250.700901 209.677117 242.586306 215.888288 240.282162 223.602162 235.473514 236.124685 225.004685 241.283964 197.154595 244.339459 158.585225 278 146.363243 277.649369 138.148468 268.082162 138.148468 252.604324 131.336216 246.994234 122.26991 246.994234 98.1765766 222.55027 97.7758559 212.832793 100.630991 203.215495 105.339459 198.557117"
        />
        <circle
          id="Oval"
          className="pulses"
          stroke="#00D5C1"
          opacity="0.25"
          cx="223.752432"
          cy="178.871712"
          r="18.1326126"
        />
        <circle
          id="Oval"
          className="pulses"
          stroke="#00D5C1"
          opacity="0.5"
          cx="223.752432"
          cy="178.871712"
          r="10.569009"
        />
        <circle
          id="Oval"
          className="pulses"
          stroke="#00D5C1"
          cx="223.752432"
          cy="178.871712"
          r="3.50630631"
        />
        <g id="Group">
          <path
            d="M171.358198,104.337658 L171.358198,10.8194595 C171.358198,5.10918919 166.74991,0.450810811 160.98955,0.450810811 C160.98955,0.450810811 20.587027,0.450810811 20.587027,0.450810811 C14.8767568,0.450810811 10.2183784,5.0590991 10.2183784,10.8194595 L10.2183784,104.287568"
            id="Shape"
            stroke="#FFFFFF"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linejoin="round"
          />
          <path
            d="M171.358198,104.337658 L181.125766,104.337658 C181.125766,113.153514 173.962883,120.316396 165.147027,120.316396 L16.4295495,120.316396 C7.61369369,120.316396 0.450810811,113.153514 0.450810811,104.337658 L10.2183784,104.337658 L171.358198,104.337658 Z"
            id="Shape"
            stroke="#FFFFFF"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linejoin="round"
          />
          <circle
            id="Oval"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            cx="90.8133333"
            cy="7.11279279"
            r="1.40252252"
          />
          <path
            d="M23.3920721,112.301982 L47.4353153,112.301982"
            id="Shape"
            stroke="#FFFFFF"
            stroke-linejoin="round"
          />
          <circle
            id="Oval"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            cx="16.7300901"
            cy="112.301982"
            r="1.25225225"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="16.7300901"
            y="13.0735135"
            width="148.116396"
            height="83.6504505"
          />
          <g
            id="Shape"
            transform="translate(90.663063, 25.545946)"
            stroke="#00D5C1"
          >
            <path className="code" d="M0.15027027,0 L58.4551351,0" />
            <path
              className="code"
              d="M0.15027027,8.46522523 L65.9686486,8.46522523"
            />
            <path
              className="code"
              d="M0.15027027,16.8803604 L38.4190991,16.8803604"
            />
            <path
              className="code"
              d="M0.15027027,25.3455856 L63.4641441,25.3455856"
            />
            <path
              className="code"
              d="M0.15027027,33.8108108 L65.9686486,33.8108108"
            />
            <path
              className="code"
              d="M0.15027027,42.2259459 L60.9596396,42.2259459"
            />
            <path
              className="code"
              d="M0.15027027,50.6911712 L65.9686486,50.6911712"
            />
            <path
              className="code"
              d="M0.15027027,59.1563964 L50.9416216,59.1563964"
            />
          </g>
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="23.3920721"
            y="65.7181982"
            width="6.76216216"
            height="18.9841441"
            className="charts-bar"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="35.4136937"
            y="54.7985586"
            width="6.76216216"
            height="29.8536937"
            className="charts-bar"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="47.4353153"
            y="58.7556757"
            width="6.76216216"
            height="25.9466667"
            className="charts-bar"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="59.4068468"
            y="42.9772973"
            width="6.76216216"
            height="41.725045"
            className="charts-bar"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-linejoin="round"
            x="71.4284685"
            y="25.5459459"
            width="6.76216216"
            height="59.1563964"
            className="charts-bar"
          />
        </g>
        <g
          id="Group"
          stroke-linecap="round"
          transform="translate(171.308108, 76.136937)"
          stroke="#FFFFFF"
        >
          <path d="M52.4443243,102.233874 L52.4443243,99.2284685" id="Shape" />
          <path
            d="M52.4443243,93.3679279 L52.4443243,31.5066667 C52.4443243,14.1754955 38.369009,0.10018018 21.0378378,0.10018018 L6.01081081,0.10018018"
            id="Shape"
            stroke-dasharray="11.7176,11.7176"
          />
          <path d="M3.0554955,0.10018018 L0.0500900901,0.10018018" id="Shape" />
        </g>
      </g>
    </g>
  </svg>
);

export default Tools;



// WEBPACK FOOTER //
// ./src/components/tools/tools.js